// =============================================================================
// Parse API error responses into human-readable messages.
// Handles FastAPI/Pydantic validation error format:
//   {"detail": [{"loc": [...], "msg": "...", "type": "..."}]}
// And simple string detail:
//   {"detail": "Some error message"}
// =============================================================================

const FIELD_LABELS: Record<string, string> = {
  email: "Email",
  password: "Password",
  display_name: "Display name",
};

function cleanMsg(msg: string): string {
  // Pydantic v2 messages often start with "Value error, " — strip that prefix
  return msg.replace(/^Value error,\s*/i, "").replace(/^value is not /i, "Not ");
}

export function parseApiError(raw: string | null | undefined): string[] {
  if (!raw) return [];

  // Try to parse as JSON
  let parsed: any;
  try {
    parsed = JSON.parse(raw);
  } catch {
    // Not JSON — return as-is
    return [raw];
  }

  // FastAPI simple detail string: {"detail": "Email already registered"}
  if (typeof parsed?.detail === "string") {
    return [parsed.detail];
  }

  // FastAPI validation error array: {"detail": [{loc, msg, type}, ...]}
  if (Array.isArray(parsed?.detail)) {
    return parsed.detail.map((err: any) => {
      const field = err.loc?.filter((l: string) => l !== "body").pop();
      const label = FIELD_LABELS[field] || field;
      const msg = cleanMsg(err.msg || "Invalid value");
      return label ? `${label}: ${msg}` : msg;
    });
  }

  // Unknown JSON shape — stringify nicely
  return [parsed.message || parsed.detail || raw];
}
